var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04688 0C6.61654 0 5.28247 0.345052 4.04468 1.03516C2.84814 1.6862 1.90605 2.57812 1.21838 3.71094C0.489461 4.88281 0.125 6.14583 0.125 7.5C0.125 8.85417 0.489461 10.1172 1.21838 11.2891C1.90605 12.4219 2.84814 13.3203 4.04468 13.9844C5.28247 14.6615 6.61654 15 8.04688 15C9.36719 15 10.605 14.707 11.7603 14.1211C12.8743 13.5612 13.7957 12.793 14.5247 11.8164L13.4519 11.0938C12.8468 11.9141 12.0766 12.5586 11.1414 13.0273C10.1786 13.5091 9.14713 13.75 8.04688 13.75C6.85034 13.75 5.73633 13.4635 4.70483 12.8906C3.7146 12.3438 2.93066 11.6016 2.35303 10.6641C1.74788 9.6875 1.44531 8.63281 1.44531 7.5C1.44531 6.36719 1.74788 5.3125 2.35303 4.33594C2.93066 3.39844 3.7146 2.65625 4.70483 2.10938C5.73633 1.53646 6.85034 1.25 8.04688 1.25C9.14713 1.25 10.1786 1.49089 11.1414 1.97266C12.0766 2.44141 12.8468 3.08594 13.4519 3.90625L14.5247 3.18359C13.7957 2.20703 12.8743 1.4388 11.7603 0.878906C10.605 0.292969 9.36719 0 8.04688 0ZM12.8949 4.55078L11.9459 5.44922L13.4519 6.875H5.40625V8.125H13.4519L11.9459 9.55078L12.8949 10.4492L15.5355 7.94922L15.9894 7.5L15.5355 7.05078L12.8949 4.55078Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogout);
export default __webpack_public_path__ + "static/media/ico-logout.efdc13b30c24464db9fcd89fb5868c42.svg";
export { ForwardRef as ReactComponent };